export default class FreeFormQuestionPresenter {
  constructor(
    readonly id: string,
    readonly text: string,
    readonly answered: boolean,
    readonly answer?: string,
    readonly isActive?: boolean,
  ) {}
}
